import { render, staticRenderFns } from "./AttestationSubmissionStatusList.vue?vue&type=template&id=63b32ca7&scoped=true"
import script from "./AttestationSubmissionStatusList.vue?vue&type=script&lang=js"
export * from "./AttestationSubmissionStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b32ca7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b32ca7')) {
      api.createRecord('63b32ca7', component.options)
    } else {
      api.reload('63b32ca7', component.options)
    }
    module.hot.accept("./AttestationSubmissionStatusList.vue?vue&type=template&id=63b32ca7&scoped=true", function () {
      api.rerender('63b32ca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationSubmissionStatus/AttestationSubmissionStatusList.vue"
export default component.exports